namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DialogLogsAib extends GContentBase {
        private cnt: JQuery<HTMLElement>;

        prepareContent() {
            this.init();
        }

        private init() {
            this.cnt = $("<div style='margin: 1rem'>").appendTo(this.element);
            this.loadLogy();
        }

        private loadLogy() {
            let html = "";
            this.cnt.empty();
            this.beginOperation();
            this.isl.AdmDiagnostikaAib.loadLogs().get().done((data) => {
                data.forEach((item) => {
                    html += `${item}<br />`
                })
                this.cnt.html(html);
            }).always(() => {
                this.endOperation()
            })
        }
    }
}